module.exports = __webpack_public_path__ + "img/arrow_1.fdab17df.png";